import { useEffect, useState } from 'react';
import React from 'react';

import helpers from './helpers'

import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham-dark.css';

import {AgGridColumn, AgGridReact} from 'ag-grid-react';

const { forwardRef, useRef, useImperativeHandle } = React;

const NewsPanel = React.forwardRef ((props, ref) => {

  const gridRef = React.useRef();

  const [aiOut, setAiOut] = useState();

  const columnDefs = [
    /*{headerName : 'Portfolio', style:{'align':'center'},
    children: [*/
    { field: 'category', headerName: 'Category', width: 150},
    { field: 'question',  headerName: 'Question', flex: 1},
  ];


  useEffect(() => {

        if ( gridRef.current.api != undefined )
        {
          setAiOut(props.aiAnswers)
        }
  }, [props.aiAnswers]);


  useEffect(() => {

        if ( props.activePanel == 'ask_ai' && gridRef.current.api != undefined )
        {
          gridRef.current.api.forEachNode(function(node) {

            if ( node.rowIndex == 0 )
            {
              node.setSelected(true);
              props.onQuestionSelect( node.data.answer )
              return;
            }
          })
          setAiOut(props.aiAnswers)
        }
      }, [props.activePanel]);

  const gridOptions = {

      rowSelection: 'single',

      onRowClicked: event => {
        //console.log("RowSelected!!!!!" + event.data.answer );
        //var replacedText = event.data.answer.replace(/\n\n/g, "\n");
        props.onQuestionSelect( event.data.answer )
      },

      onColumnResized: event => console.log('A column was resized'),

      onGridReady: event =>
      {
      },
  }


   return (

     <div>
       <div className="ag-theme-balham-dark" style={{height:"35vh"}}>
           <AgGridReact rowData={aiOut} columnDefs={columnDefs} gridOptions={gridOptions} ref={gridRef}>
           </AgGridReact>
       </div>
       </div>
     )
  });

export default NewsPanel;
